<template>
  <div class="list">
    <div class="content-wrapper">
      <template v-for="(item,index) in classList">
        <div class="item">
          <img class="lesson-img" width="186" height="122" :src="imgprefix+item.lessonfaceimg" alt="课程图片">
          <div class="info-wrapper">
            <h2 class="info-title">{{decodeURIComponent(item.lessonname)}}</h2>
            <p class="row">学生姓名:{{decodeURIComponent(item.username)}}</p>
<!--            <p class="row">联系电话:{{decodeURIComponent(item.phone)}}</p>-->
            <p class="row">上课时间:{{item.startdate.substring(0,10)}}
              {{item.starttime.substring(0,5)}}-{{item.endtime.substring(0,5)}}</p>
          </div>
          <div class="btn-wrapper">
            <template v-if="item.isconfirm=='0'">
              <button class="confrim" @click="confirmRecord(item,index)">立即确认</button>
              <button class="cancel" @click="cancelRecord(item,index)">忽略此条记录</button>
            </template>
            <template v-if="item.isconfirm=='1'">
              <button class="confrimed-btn">已确认</button>
            </template>
            <template v-if="item.isconfirm=='2'">
              <button class="canceled-btn">已忽略</button>
            </template>
          </div>
        </div>
      </template>
      <div class="noresult" v-if="isEmpty(classList)">
        <img src="./noresult.png" width="290" height="164" alt="没有结果">
        <p class="noresult-text">~暂无学生报名试听课~</p>
      </div>
      <template v-if="!isEmpty(classList)&&classList.length>10">
        <el-pagination
          background
          layout="prev, pager, next"
          :current-page.sync="currentPage"
          @current-change="handleCurrentChange"
          :page-size="10"
          :total="totoalPage">
        </el-pagination>
      </template>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
  import {saveLocal, loadLocal} from 'common/js/store.js';

  export default {
    data() {
      return {
        id: (() => loadLocal('id', false))(),
        schoolNow: (() => loadLocal('schoolNow', false))(),
        imgprefix: '',
        currentPage: 1,
        totoalPage: 1,
        classList: [],
        itemStatus: null,
      }
    },
    methods: {
      isEmpty(obj) {
        for (let i in obj) {
          return !1;
        }
        return !0;
      },
      confirmRecord(item, index) {
        let params = Object.create(null);
        params.rid = item.rid;
        params.classid = item.classid;
        params.catalog_index = item.catalog_index;
        params.isconfirm = 1;
        this.itemStatus='1';
        this.UpdateFreeClassConfirm(index, params);
      },
      cancelRecord(item,index){
        let params = Object.create(null);
        params.rid = item.rid;
        params.classid = item.classid;
        params.catalog_index = item.catalog_index;
        params.isconfirm = 2;
        this.itemStatus='2';
        let _this=this;
        this.$confirm('确定要忽略此条记录吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          _this.UpdateFreeClassConfirm(index, params);
        }).catch(() => {
        });
      },
      UpdateFreeClassConfirm(index, obj) {
        let params = {
          c: 'Lesson',
          a: 'UpdateFreeClassConfirm',
          id: this.id,
        };
        for (let i = 0, keys = Object.keys(obj); i < keys.length; i++) {
          params[keys[i]] = obj[keys[i]]
        }
        this.$http({
          url: '/indexapp.php',
          method: 'GET',
          params: params
        }).then((response) => {
          response = response.data;
          if (response.code === 200) {
            this.$message({
              message: '操作成功',
              type: 'success'
            });
            this.classList[index].isconfirm = this.itemStatus;
            this.$forceUpdate();
          } else {
            this.$message({
              message: response.msg,
              type: 'warning'
            });
          }
        }).catch((err) => {
        })
      },
      QueryFreeClassApply(pageNumber) {
        this.$http({
          url: '/indexapp.php',
          method: 'GET',
          params: {
            c: 'Lesson',
            a: 'QueryFreeClassApply',
            id: this.id,
            pageno: pageNumber,
            pagesize: 10,
            rid: this.schoolNow.rid,
          }
        }).then((response) => {
          response = response.data;
          if (response.code === 111) {
            this.$router.push({path: '/log', query: {url: this.$getUrl.getUrl()}});
          }
          if (response.code === 200) {
            if (!this.imgprefix) {
              this.imgprefix = response.imgprefix;
            }
            this.classList = response.list;
          }
        }).catch((err) => {
        })
      }
    },

    created() {
      this.QueryFreeClassApply(1);
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  .list
    width: 100%
    height: 100%
    background: #f2f2f2
    font-size: 0
    overflow auto
    .content-wrapper
      margin: 111px 20px 20px 180px
      width: 1166px
      .item
        background: #fff
        padding: 20px
        margin-bottom: 10px
        overflow: hidden
        .lesson-img
          float: left
        .info-wrapper
          float: left
          margin-left: 20px
          .info-title
            margin-bottom: 20px
            height: 22px
            line-height: 22px
            font-size: 16px
            color: #333
          .row
            margin-bottom: 4px
            height: 20px
            line-height: 20px
            font-size: 14px
            color: #999

        .btn-wrapper
          float: right
          width: 120px
          text-align: center
          margin-top: 44px
          .confrim
            display: block
            width: 120px
            text-align: center
            height: 34px
            line-height: 34px
            font-size: 14px
            color: #ffffff
            background: #3399ff
            border-radius: 4px
            &:hover
              background: #2086ec
          .cancel
            display: inline-block
            margin-top: 8px
            font-size: 14px
            color: #999999
            width: 90px
            height: 20px
            line-height: 20px
            &:hover
              color: #3399ff

          .confrimed-btn
            display: block
            width: 120px
            text-align: center
            height: 34px
            line-height: 34px
            font-size: 14px
            color: #ffffff
            background: #ccc
            border-radius: 4px
          .canceled-btn
            display: inline-block
            font-size: 14px
            color: #ccc
            width: 90px
            height: 20px
            line-height: 20px
  .noresult
    background: #fff
    height: 550px
    padding-top: 120px
    text-align: center
    box-sizing: border-box
    .noresult-text
      font-size: 18px
      color: #a5a5a5
      margin-top: 10px
      line-height: 25px

</style>



// WEBPACK FOOTER //
// src/page/confirmenroll/confirmclass/ConfirmClass.vue